











import { defineComponent } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'

import { useContentTarget } from '~/composables/cms/useContentTarget'

import LegalStatement from '~/components/global/targeters/content-components/LegalStatement.vue'
import Generic from '~/components/global/targeters/content-components/Generic.vue'
import AdditionalInformation from '~/components/global/targeters/content-components/AdditionalInformation.vue'

export default defineComponent({
  components: {
    LegalStatement,
    Generic,
    AdditionalInformation,
  },
  props: {
    devkey: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { listOfFragments } = useContentTarget(props.devkey)

    return {
      listOfFragments,
      isEmpty,
    }
  },
})
